(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sidebar-left"]) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('.ex-sidebar').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const rail = root.querySelector('.ex-sidebar__rail');
    const fitRail = () => {
      const top = Math.max(0, rail.getBoundingClientRect().top);
      rail.style.maxHeight = `${Math.max(120, window.innerHeight - top - 80)}px`;
    };
    fitRail();
    new ResizeObserver(fitRail).observe(root);
    const groups = [...root.querySelectorAll('.ex-sidebar__group')];
    const close = (group, focus = false) => {
      group.open = false;
      group.querySelector('summary').setAttribute('aria-expanded', 'false');
      if (focus) group.querySelector('summary').focus();
    };
    const position = group => {
      const panel = group.querySelector('.ex-sidebar__panel');
      const bounds = rail.getBoundingClientRect();
      const viewport = window.visualViewport;
      const height = viewport ? viewport.height : window.innerHeight;
      const top = Math.max(8, Math.min(bounds.top, height - 180));
      panel.style.left = `${bounds.right}px`;
      panel.style.top = `${top}px`;
      panel.style.maxHeight = `${Math.max(120, height - top - 72)}px`;
      panel.style.maxWidth = `${Math.max(180, window.innerWidth - bounds.right - 12)}px`;
    };
    groups.forEach(group => {
      const trigger = group.querySelector('summary');
      trigger.setAttribute('aria-expanded', 'false');
      group.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(group.open));
        if (group.open) {
          groups.filter(other => other !== group && other.open).forEach(other => close(other));
          position(group);
        }
      });
      group.querySelector('.ex-sidebar__close').addEventListener('click', () => close(group, true));
      group.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(group, true); event.stopPropagation(); }
      });
    });
    document.addEventListener('click', event => {
      if (!root.contains(event.target)) groups.filter(g => g.open).forEach(g => close(g));
    });
    root.addEventListener('focusout', () => setTimeout(() => {
      if (!root.contains(document.activeElement)) groups.filter(g => g.open).forEach(g => close(g));
    }, 0));
    window.addEventListener('resize', () => { fitRail(); groups.filter(g => g.open).forEach(position); });
    window.addEventListener('scroll', () => { fitRail(); groups.filter(g => g.open).forEach(position); }, {passive:true});
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
